import { SearchClient } from "algoliasearch";
import React from "react";

export const AlgoliaContext = React.createContext<SearchClient | null>(null);
